import type { DocumentReference, Reference } from '@medplum/fhirtypes'
import { ExtendedDocumentReference } from '@seen/core/models/document-references/documentReferences'
import { cn } from '@seen/ui'
import { IconFile } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useState } from 'react'
import { DocumentReferenceSheet } from '#src/components/document-reference/DocumentReferenceSheet.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function DocumentReferenceMention({
  documentReference: documentReferenceRef,
  className,
  displayOverride,
}: {
  documentReference: Reference<DocumentReference>
  className?: string
  displayOverride?: string | null
}): JSX.Element {
  const [sheetOpen, setSheetOpen] = useState(false)

  const { data: documentReference } = useRead(
    ExtendedDocumentReference,
    documentReferenceRef
  )

  return (
    <>
      <button
        type="button"
        onClick={() => setSheetOpen(true)}
        className={cn(
          'inline select-none rounded-sm border-[0.5px] border-gray-450 bg-gray-470 box-decoration-clone px-1 py-px text-left hover:bg-gray-460 group-[.ProseMirror-selectednode]:bg-[lch(53_52.26_286.91/0.4)]',
          className
        )}
        tabIndex={-1}
      >
        <span>
          <IconFile className="inline-block size-[1em] align-[-0.25ex]" />
        </span>
        <span> {displayOverride || documentReference?.title}</span>
      </button>
      <DocumentReferenceSheet
        documentReference={documentReference}
        open={sheetOpen}
        setOpen={setSheetOpen}
        hideParticipant
      />
    </>
  )
}
